import React, { useState } from 'react';
import ServiceRequestCard from './ServiceRequestCard';

// "Service requests" on an on-call customer's card (migration 102): the same
// 14-day picker, note, Cancel and history the customer has in the portal,
// entered by the owner (source 'owner'). The server keeps requests on the
// root customer, so a property card shows its customer's requests.
//
// Collapsed until opened, like Texts beside it, so a long list of cards costs
// no requests until someone looks; the card loads each time it is opened.
export default function CustomerServiceRequests({ customerId }) {
  const [open, setOpen] = useState(false);
  const base = `${process.env.REACT_APP_API_URL}/api/customers/${customerId}/service-requests`;
  return (
    <div className="customer-service-requests" style={{ marginTop: '8px' }}>
      <button
        type="button"
        className="btn btn-link btn-sm"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        style={{ padding: 0, fontSize: '0.8125rem' }}
      >
        {open ? '▼' : '▶'} Service requests
      </button>
      {open && (
        <ServiceRequestCard
          loadUrl={base}
          createUrl={base}
          cancelUrl={(id) => `${base}/${id}/cancel`}
          title="Service requests"
          intro="Days this on-call customer wants service. Pick one or more."
          submitLabel="Add dates"
          variant="owner"
        />
      )}
    </div>
  );
}
